interface IFormatGridColumn {
    span: number | null;
    isMobile: boolean;

    maxRowWidthDesktop: number | null;
    maxRowWidthMobile: number | null;
}

export function formatGridColumn({span, isMobile, maxRowWidthDesktop, maxRowWidthMobile}: IFormatGridColumn): string | undefined {
    if (isMobile) {
        if (maxRowWidthMobile !== null) {
            if (span !== null) {
                return `span ${span}`;
            }
        }

        return undefined;
    } else {
        if (maxRowWidthDesktop !== null) {
            if (span !== null) {
                return `span ${span}`;
            }
        }

        return undefined;
    }
}
